export const otherTaxesData = [
    {
        id: "1",
        code: "1",
        myData: 1,
        name: "α1) ασφάλιστρα κλάδου πυρός 20%",
        tax: "20",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3,
        accounting: "63.98.06.0000",
    },
    {
        id: "2",
        code: "2",
        myData: 2,
        name: "α2) ασφάλιστρα κλάδου πυρός 20%",
        tax: "20",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3,
        accounting: "63.98.06.0000",
    },
    {
        id: "3",
        code: "3",
        myData: 3,
        name: "β)ασφάλιστρα κλάδου ζωής 4%",
        tax: "4",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "4",
        code: "4",
        myData: 4,
        name: "γ) ασφάλιστρα λοιπών κλάδων 15%",
        tax: "15",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "5",
        code: "5",
        myData: 5,
        name: "δ) απαλλασσόμενα φόρου ασφαλίστρων 0%",
        tax: "0",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "6",
        code: "6",
        myData: 6,
        name: "Ξενοδοχεία 1-2 αστέρων 0,50€",
        tax: "0.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "7",
        code: "7",
        myData: 7,
        name: "Ξενοδοχεία 3 αστέρων 1,50€",
        tax: "1.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "8",
        code: "8",
        myData: 8,
        name: "Ξενοδοχεία 4 αστέρων 3,00€",
        tax: "3",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "9",
        code: "9",
        myData: 9,
        name: "Ξενοδοχεία 5 αστέρων 4,00€",
        tax: "4",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "10",
        code: "10",
        myData: 10,
        name: "Ενοικιαζόμενα- Επιπλωμένα δωμάτια- διαμερίσματα 0,50€",
        tax: "0.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "11",
        code: "11",
        myData: 11,
        name: "Ειδικός φόρος στις διαφημίσεις που προβάλλονται απο την τηλεόραση (ΕΦΤΔ) 5%",
        tax: "5",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "12",
        code: "12",
        myData: 12,
        name: "3.1 Φόρος Πολυτελείας 10% επί της φορολογούμενης αξίας για τα ενδοικοινοτικώς αποκτούμενα και εισαγόμενα από τρίτες χώρες",
        tax: "10",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "13",
        code: "13",
        myData: 13,
        name: "3.2 Φόρος πολυτελείας 10% επί της τιμής πώλησης προ ΦΠΑ για τα εγχωρίως παραγόμενα είδη",
        tax: "10",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "14",
        code: "14",
        myData: 14,
        name: "Δικαίωμα του Δημοσίου στα εισιτήρια των καζίνο (80% επί του εισιτηρίου)",
        tax: "80",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "15",
        code: "15",
        myData: 15,
        name: "ασφάλιστρα κλάδου πυρός 20%",
        tax: "20",
        taxPer: "true",
        taxAmount: "false",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3,
        accounting: "63.98.06.0000",
    },
    {
        id: "16",
        code: "16",
        myData: 16,
        name: "Λοιποί Τελωνειακοί Δασμοί-Φόροι",
        tax: "0",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "17",
        code: "17",
        myData: 17,
        name: "Λοιποί Φόροι",
        tax: "0",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "18",
        code: "18",
        myData: 18,
        name: "Επιβαρύνσεις Λοιπών Φόρων",
        tax: "0",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "19",
        code: "19",
        myData: 19,
        name: "ΕΦΚ",
        tax: "0",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 1,
        vatIncluded : 3
    },
    {
        id: "20",
        code: "20",
        myData: 20,
        name: "Ξενοδοχεία 1-2 αστέρων 1,50€ (ανά Δωμ./Διαμ.)",
        tax: "1.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "21",
        code: "21",
        myData: 21,
        name: "Ξενοδοχεία 3 αστέρων 3,00€ (ανά Δωμ./Διαμ.)",
        tax: "3",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "22",
        code: "22",
        myData: 22,
        name: "Ξενοδοχεία 4 αστέρων 7,00€ (ανά Δωμ./Διαμ.)",
        tax: "7",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "23",
        code: "23",
        myData: 23,
        name: "Ξενοδοχεία 5 αστέρων 10,00€ (ανά Δωμ./Διαμ.)",
        tax: "10",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "24",
        code: "24",
        myData: 24,
        name: "Ενοικιαζόμενα επιπλωμένα δωμάτια – διαμερίσματα 1,50€ (ανά Δωμ./Διαμ.)",
        tax: "1.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "25",
        code: "25",
        myData: 25,
        name: "Ακίνητα βραχυχρόνιας μίσθωσης 1,50€",
        tax: "1.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "26",
        code: "26",
        myData: 26,
        name: "Ακίνητα βραχυχρόνιας μίσθωσης μονοκατοικίες άνω των 80 τ.μ. 10,00€",
        tax: "10",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "27",
        code: "27",
        myData: 27,
        name: "Αυτοεξυπηρετούμενα καταλύματα – τουριστικές επιπλωμένες επαύλεις (βίλες) 10,00€",
        tax: "10",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "28",
        code: "28",
        myData: 28,
        name: "Ακίνητα βραχυχρόνιας μίσθωσης 0,50€",
        tax: "0.5",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
    {
        id: "29",
        code: "29",
        myData: 29,
        name: "Ακίνητα βραχυχρόνιας μίσθωσης μονοκατοικίες άνω των 80 τ.μ. 4,00€",
        tax: "4",
        taxPer: "false",
        taxAmount: "true",
        vatPercentage: 0,
        taxLevel: 2,
        vatIncluded : 3,
        accounting: "63.98.99.0000",
    },
]


export const otherTaxesDropdownOptions = [
    {
        "id": "1",
        "label": "α1) ασφάλιστρα κλάδου πυρός 20%",
        "value": 1,
        "color": "#76AEB7"
    },
    {
        "id": "2",
        "label": "α2) ασφάλιστρα κλάδου πυρός 20%",
        "value": 2,
        "color": "#76AEB7"
    },
    {
        "id": "3",
        "label": "β)ασφάλιστρα κλάδου ζωής 4%",
        "value": 3,
        "color": "#76AEB7"
    },
    {
        "id": "4",
        "label": "γ) ασφάλιστρα λοιπών κλάδων 15%",
        "value": 4,
        "color": "#76AEB7"
    },
    {
        "id": "5",
        "label": "δ) απαλλασσόμενα φόρου ασφαλίστρων 0%",
        "value": 5,
        "color": "#76AEB7"
    },
    {
        "id": "6",
        "label": "Ξενοδοχεία 1-2 αστέρων 0,50€",
        "value": 6,
        "color": "#76AEB7"
    },
    {
        "id": "7",
        "label": "Ξενοδοχεία 3 αστέρων 1,50€",
        "value": 7,
        "color": "#76AEB7"
    },
    {
        "id": "8",
        "label": "Ξενοδοχεία 4 αστέρων 3,00€",
        "value": 8,
        "color": "#76AEB7"
    },
    {
        "id": "9",
        "label": "Ξενοδοχεία 5 αστέρων 4,00€",
        "value": 9,
        "color": "#76AEB7"
    },
    {
        "id": "10",
        "label": "Ενοικιαζόμενα- Επιπλωμένα δωμάτια- διαμερίσματα 0,50€",
        "value": 10,
        "color": "#76AEB7"
    },
    {
        "id": "11",
        "label": "Ειδικός φόρος στις διαφημίσεις που προβάλλονται απο την τηλεόραση (ΕΦΤΔ) 5%",
        "value": 11,
        "color": "#76AEB7"
    },
    {
        "id": "12",
        "label": "3.1 Φόρος Πολυτελείας 10% επί της φορολογούμενης αξίας  για τα ενδοικοινοτικώς",
        "value": 12,
        "color": "#76AEB7"
    },
    {
        "id": "13",
        "label": "3.2 Φόρος πολυτελείας 10% επί της τιμής πώλησης προ ΦΠΑ για τα εγχωρίως παραγόμενα είδη 10%",
        "value": 13,
        "color": "#76AEB7"
    },
    {
        "id": "14",
        "label": "Δικαίωμα του Δημοσίου στα εισιτήρια των καζίνο (80% επί του εισιτηρίου)",
        "value": 14,
        "color": "#76AEB7"
    },
    {
        "id": "15",
        "label": "ασφάλιστρα κλάδου πυρός 20%",
        "value": 15,
        "color": "#76AEB7"
    },
    {
        "id": "16",
        "label": "Λοιποί Τελωνειακοί Δασμοί-Φόροι",
        "value": 16,
        "color": "#76AEB7"
    },
    {
        "id": "17",
        "label": "Λοιποί Φόροι",
        "value": 17,
        "color": "#76AEB7"
    },
    {
        "id": "18",
        "label": "Επιβαρύνσεις Λοιπών Φόρων",
        "value": 18,
        "color": "#76AEB7"
    },
    {
        "id": "19",
        "label": "ΕΦΚ",
        "value": 19,
        "color": "#76AEB7"
    },
    {
        "id": "20",
        "label": "Ξενοδοχεία 1-2 αστέρων 1,50€ (ανά Δωμ./Διαμ.)",
        "value": 20,
        "color": "#76AEB7"
    },
    {
        "id": "21",
        "label": "Ξενοδοχεία 3 αστέρων 3,00€ (ανά Δωμ./Διαμ.)",
        "value": 21,
        "color": "#76AEB7"
    },
    {
        "id": "22",
        "label": "Ξενοδοχεία 4 αστέρων 7,00€ (ανά Δωμ./Διαμ.)",
        "value": 22,
        "color": "#76AEB7"
    },
    {
        "id": "23",
        "label": "Ξενοδοχεία 5 αστέρων 10,00€ (ανά Δωμ./Διαμ.)",
        "value": 23,
        "color": "#76AEB7"
    },
    {
        "id": "24",
        "label": "Ενοικιαζόμενα επιπλωμένα δωμάτια – διαμερίσματα 1,50€ (ανά Δωμ./Διαμ.)",
        "value": 24,
        "color": "#76AEB7"
    },
    {
        "id": "25",
        "label": "Ακίνητα βραχυχρόνιας μίσθωσης 1,50€",
        "value": 25,
        "color": "#76AEB7"
    },
    {
        "id": "26",
        "label": "Ακίνητα βραχυχρόνιας μίσθωσης μονοκατοικίες άνω των 80 τ.μ. 10,00€",
        "value": 26,
        "color": "#76AEB7"
    },
    {
        "id": "27",
        "label": "Αυτοεξυπηρετούμενα καταλύματα – τουριστικές επιπλωμένες επαύλεις (βίλες) 10,00€",
        "value": 27,
        "color": "#76AEB7"
    },
    {
        "id": "28",
        "label": "Ακίνητα βραχυχρόνιας μίσθωσης 0,50€",
        "value": 28,
        "color": "#76AEB7"
    },
    {
        "id": "29",
        "label": "Ακίνητα βραχυχρόνιας μίσθωσης μονοκατοικίες άνω των 80 τ.μ. 4,00€",
        "value": 29,
        "color": "#76AEB7"
    },
]

export const otherTaxesTaxLevel = [
    {
        "no": 1,
        "label": "Σε επίπεδο παραστατικού",
        "value": 1,
        "color": "#76AEB7"
    },
    {
        "no": 2,
        "label": "Σε επίπεδο γραμμής παραστατικού",
        "value": 2,
        "color": "#76AEB7"
    }
]

export const otherTaxesVatIncluded = [
    {
        "no": 1,
        "label": "Συμπεριλαμβάνει ΦΠΑ",
        "value": 1,
        "color": "#76AEB7"
    },
    {
        "no": 2,
        "label": "Δεν συμπεριλαμβάνει ΦΠΑ",
        "value": 2,
        "color": "#76AEB7"
    },
    {
        "no": 3,
        "label": "Εξαιρείται ΦΠΑ",
        "value": 3,
        "color": "#76AEB7"
    }
]
